import { Component } from '@angular/core';
import { NavParams, ViewController, ToastController } from 'ionic-angular';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
declare var jQuery: any;

@Component({
  selector: 'scheduler-mail-time-popup',
  templateUrl: 'scheduler-mail-time-popup.html',
})
export class SchedulerMailTimePopupComponent {

  text: string;
  weeklySchedule: any = false;
  monthlySchedule: any = false;
  dailySchedule: any = false;
  oneTimeSchedule: any = false;
  objScheduleData: any;
  hourSchedule: boolean = false;
  timepickerVisible = false;
  defaultOption: any = 'Choose...';
  objData: any = {};
  clearDateFlag: boolean = false;
  onselectDate: boolean = false;
  showClearButton: boolean = false;
  // settings = {
  //   bigBanner: true,
  //   timePicker: true,
  //   datePicker: false,
  //   monthPicker: false,
  //   format: 'hh:mm',
  //   defaultOpen: false,
  //   closeOnSelect: true
  // }
  openDatePicker: boolean = true;
  // currentDate : Date  
  // currentDate : Date=new Date();
  currentDate: Date = null;
  // defaultDate : Date = new Date('1900-01-01');
  defaultDate: any = '1900-01-01'
  checkDefDate: any = '1900-01-01';
  scheduleDataTime: Date;
  daily = [{
    "key": "Hour", "value": "Hour"
  }, { "key": "Minute", "value": "Minute" }]
  everyday = [{
    "key": "Sunday", "value": "Sunday"
  }, { "key": "Monday", "value": "Monday" },
  { "key": "Tuesday", "value": "Tuesday" },
  { "key": "Wednesday", "value": "Wednesday" },
  { "key": "Thursday", "value": "Thursday" },
  { "key": "Friday", "value": "Friday" },
  { "key": "Saturday", "value": "Saturday" },
  ]
  DailySchedule: any = this.defaultOption;
  weeklyDaySchedule: any;
  objEvent: any = [
    { 'key': "Hour", "value": "Hour" },
    { 'key': "Day", "value": "Day" },
    { 'key': "Month", "value": "Month" },
    { 'key': "Onetime", "value": "OneTime" },
  ]
  defSettings: any = {
    bigBanner: false,
    timePicker: false,
    format: 'yyyy-MM-dd',
    defaultOpen: false,
  }
  oneTimeDate: any;
  constructor(public toastCtrl: ToastController, public configService: ConfigureServiceProvider, public viewCtrlScheduler: ViewController, public configApiService: ConfigApiServiceProvider, public navParams: NavParams, public datePipe: DatePipe) {
    this.objScheduleData = { 'Time': Date };
  }

  timeChanged() {
    this.objScheduleData.Time = ("0" + this.scheduleDataTime.getHours()).slice(-2) + ':' + ("0" + this.scheduleDataTime.getMinutes()).slice(-2);
  }

  ngOnInit() {
    this.objScheduleData = this.navParams.get('data');
    this.scheduleDataTime = new Date();
    if (this.objScheduleData.Time) {
      this.scheduleDataTime.setHours(this.objScheduleData.Time.split(':')[0]);
      this.scheduleDataTime.setMinutes(this.objScheduleData.Time.split(':')[1]);
    }
    this.scheduleType(this.objScheduleData.Event);
  }

  formatDate(d) {
    var date;
    if (d != null) {
      date = new Date(d);
    } else {
      date = new Date();
    }
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    return date;
  };
  /* * * * * *
  * onclick to set current date
  * * * * * */
  onSelectDate(e) {
    if (this.clearDateFlag) {
      this.clearDateFlag = false;
      jQuery("#" + this.objScheduleData.Date + " .wc-date-popover").removeAttr('hidden');
    }
    if (e === this.checkDefDate) {
      this.objScheduleData.Date = this.datePipe.transform(this.currentDate, 'hh:mm');
    } else {
      if (this.onselectDate) {
        this.onselectDate = false;
        this.objScheduleData.Date = this.objScheduleData.Date;
      }
    }



  }
  onSelectOneTimeDate(date) {
    this.oneTimeDate = moment(date).format('YYYY-MM-DD');
    this.objScheduleData.Date = this.oneTimeDate
  }
  clearDate() {
    this.showClearButton = false;
    this.objScheduleData.Date = this.datePipe.transform(this.defaultDate, 'hh:mm');
    setTimeout(() => {
      jQuery("#" + this.objScheduleData.Date + " .wc-date-container span").text("");
      jQuery("#" + this.objScheduleData.Date + " .wc-date-popover").attr("hidden", true);
      this.clearDateFlag = true;
    }, 10);
  }

  /* * * * * *
  * onselect date
  * * * * * */
  onDateSelect(e) {
    this.showClearButton = true;
    this.onselectDate = true;
    this.objScheduleData.Date = this.
      datePipe.transform(e, 'hh:mm');

  }
  scheduleType(e) {
    this.objScheduleData.Event = e;
    if (e == "Day") {
      this.monthlySchedule = false;
      this.dailySchedule = true;
      this.hourSchedule = false;
      this.oneTimeSchedule = false;
    } else if (e == "Month") {
      this.monthlySchedule = true;
      this.dailySchedule = false;
      this.hourSchedule = false;
      this.oneTimeSchedule = false;
    } else if (e == "Hour") {
      this.monthlySchedule = false;
      this.dailySchedule = false;
      this.hourSchedule = true;
      this.oneTimeSchedule = false;
    } else if (e == "Onetime") {
      this.monthlySchedule = false;
      this.dailySchedule = false;
      this.oneTimeSchedule = true;
      this.hourSchedule = false;
    }
  }
  schedulevalue(event) {
    this.DailySchedule = event.event;
    this.objScheduleData.Schedule = event.event;

  }
  weeklyschedulevalue(event) {
    this.weeklyDaySchedule = event.event;
    this.objScheduleData.Schedule = event.event;
  }
  saveScheduler(e) {
    let defaultRage = 0
    if (this.oneTimeDate == undefined && this.oneTimeSchedule) {
      this.oneTimeDate = new Date()
      this.objScheduleData.Date = moment(this.oneTimeDate).format("YYYY-MM-DD");
    }
    if (this.objScheduleData.Event == "Monthly") {
      this.objScheduleData.Schedule = this.objScheduleData.Range;
    }
    if (this.objScheduleData.Event == "Onetime") {
      this.objScheduleData.Range = defaultRage
    }
    this.objData = Object.assign({}, this.configApiService.driveApi.pushmailschedule.params, this.objScheduleData, { "client": this.configService.getStudio() });
    if (this.objScheduleData.Event != "Hour" && this.objData['Time'] == "") {
      this.objData.Time = ("0" + new Date().getHours()).slice(-2) + ':' + ("0" + new Date().getMinutes()).slice(-2)
    }
    this.objData.Schedule = this.objScheduleData.Event != "Hour" && this.objScheduleData.Event != "Day " ? this.objScheduleData.Schedule : '';
    this.objData.Time = this.objScheduleData.Event != "Hour" ? this.objData.Time : '';
    if (this.objData.Event == "Weekly") {
      if (this.objData.Schedule == "") {
        this.objData.Range = "";
        this.objData.Schedule = "";
        let message = this.toastCtrl.create({
          message: 'Please Enter Shedule !!!',
          duration: 2000
        });
        message.present();
      } else {
        this.closeScheduler()
      }
    } else if (this.objData.Event == "Monthly") {
      if (this.objData.Range == "") {
        this.objData.Range = "";
        this.objData.Schedule = "";
        let message = this.toastCtrl.create({
          message: 'Please Enter Range !!!',
          duration: 2000
        });
        message.present();
      } else {
        this.closeScheduler()
      }
    } else {
      this.closeScheduler()
    }
    // }

  }

  schedulerSaveSucess = ((respData) => {
    let message = this.toastCtrl.create({
      message: 'Scheduled Successfully!!!',
      duration: 2000
    });
    message.present();
    this.closeScheduler();
  })

  closeScheduler() {
    this.viewCtrlScheduler.dismiss(this.objData);
  }


}



// WEBPACK FOOTER //
// ./src/components/scheduler-mail-time-popup/scheduler-mail-time-popup.ts